<script setup lang="ts">
withDefaults(
  defineProps<{
    error?: boolean;
  }>(),
  { error: false }
);
</script>

<template>
  <Icon :name="!error ? 'carbon:checkmark-outline' : 'carbon:close-outline'" :class="['text-xl', error ? 'text-red-500' : 'text-green-500']"></Icon>
</template>
